// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"Hamburger_hamburger__3HIW1","open":"Hamburger_open__1m5EA","close":"Hamburger_close__3HuT3","opened":"Hamburger_opened__3tSJw"};